import type { OpenedBiometricVault } from '../biometric-vault';
import type { NativePhone } from '../native-phone';
import type { NativeStorage } from '../native-storage';
import type { Revivers } from '../native-stores';

/**
 * Where the app runs — and the one file that knows it. This is the web's answer: a browser. The
 * `native` configuration (angular.json) swaps this file for platform.native.ts, so the answer is
 * decided when the bundle is built and the web bundle carries nothing of the native shell — not
 * even a chunk: the native modules are imported from platform.native.ts only, which the web build
 * never reads.
 *
 * Only the composition root (src/app/app.config.ts) reads it, to choose the adapters
 * (eslint.config.js); screens, use cases and the domain never know where they run.
 */
export const RUNS_NATIVE = false as boolean;

/** The apps' own storage; a browser has none, and the web build never calls this. */
export const openNativeStorage: (revivers: Revivers) => Promise<NativeStorage> = () =>
  Promise.reject(new Error('A browser has no native storage.'));

/** The phone's share sheet, PDF files and received backups; a browser has none either. */
export const openNativePhone: () => Promise<NativePhone> = () =>
  Promise.reject(new Error('A browser is not a phone app.'));

/** The phrase behind the fingerprint or the face; a browser has no secure hardware of the kind. */
export const openBiometric: () => Promise<OpenedBiometricVault> = () =>
  Promise.reject(new Error('A browser keeps no phrase behind a fingerprint.'));
